export enum OrderStatus {
  WAITING_PAYMENT = {
    code: 'WAITING_PAYMENT',
    description: 'ORDERS.WAITING_PAYMENT',
    itemDescription: 'ORDERS.ITEM_WAITING_PAYMENT',
    icon: 'custom-queue',
    color: 'primary',
    chartLabel: 'ORDERS.ITEM_WAITING_PAYMENT',
    chartColor: '#EF6C00',
    ordination: 1,
  } as any,
  RESERVED = {
    code: 'RESERVED',
    description: 'ORDERS.RESERVED',
    itemDescription: 'ORDERS.ITEM_RESERVED',
    icon: 'custom-queue',
    color: 'primary',
    chartLabel: 'ORDERS.ITEM_IN_QUEUE',
    chartColor: '#EF6C00',
    ordination: 1,
  } as any,
  IN_QUEUE = {
    code: 'IN_QUEUE',
    description: 'ORDERS.IN_QUEUE',
    itemDescription: 'ORDERS.ITEM_IN_QUEUE',
    icon: 'custom-queue',
    color: 'red',
    chartLabel: 'ORDERS.ITEM_IN_QUEUE',
    chartColor: '#EE8471',
    ordination: 1,
  } as any,
  IN_PRODUCTION = {
    code: 'IN_PRODUCTION',
    description: 'ORDERS.IN_PRODUCTION',
    itemDescription: 'ORDERS.ITEM_IN_PRODUCTION',
    icon: 'custom-chef',
    color: 'primary',
    chartLabel: 'ORDERS.IN_PRODUCTION',
    chartColor: '#F5BE31',
    ordination: 2,
  } as any,
  PARTIAL_DELIVERED = {
    code: 'PARTIAL_DELIVERED',
    description: 'ORDERS.PARTIAL_DELIVERED',
    itemDescription: 'ORDERS.ITEM_IN_PRODUCTION',
    icon: 'custom-chef',
    color: 'primary',
    chartLabel: 'ORDERS.PARTIAL_DELIVERED',
    chartColor: '#F5BE31',
    ordination: 3,
  } as any,
  FINISHED = {
    code: 'FINISHED',
    description: 'ORDERS.FINISHED',
    itemDescription: 'ORDERS.ITEM_FINISHED',
    icon: 'custom-checkmark',
    color: 'green',
    chartLabel: 'ORDERS.FINISHED',
    chartColor: '#A4D6C5',
    ordination: 4,
  } as any,
  DELIVERED = {
    code: 'DELIVERED',
    description: 'ORDERS.DELIVERED',
    itemDescription: 'ORDERS.ITEM_DELIVERED',
    icon: 'custom-checkmark',
    color: 'green',
    chartLabel: 'ORDERS.FINISHED',
    chartColor: '#A4D6C5',
    ordination: 5,
  } as any,
  RATED = {
    code: 'RATED',
    description: 'ORDERS.RATED',
    itemDescription: 'ORDERS.ITEM_RATED',
    icon: 'custom-star',
    color: 'yellow',
    chartLabel: 'ORDERS.FINISHED',
    chartColor: '#A4D6C5',
    ordination: 6,
  } as any,
  CANCELED_BY_ESTABLISHMENT = {
    code: 'CANCELED_BY_ESTABLISHMENT',
    description: 'ORDERS.CANCELED_BY_ESTABLISHMENT',
    itemDescription: 'ORDERS.ITEM_CANCELED',
    icon: 'custom-cancel',
    color: 'dark',
    chartLabel: 'ORDERS.CANCELED_BY_ESTABLISHMENT',
    chartColor: '#F5BE31',
    ordination: 7,
  } as any,
  CANCELED_BY_CUSTOMER = {
    code: 'CANCELED_BY_CUSTOMER',
    description: 'ORDERS.CANCELED_BY_CUSTOMER',
    itemDescription: 'ORDERS.ITEM_CANCELED',
    icon: 'custom-cancel',
    color: 'dark',
    chartLabel: 'ORDERS.CANCELED_BY_CUSTOMER',
    chartColor: '#EE8471',
    ordination: 8,
  } as any,
  NON_PAYMENT = {
    code: 'NON_PAYMENT',
    description: 'ORDERS.NON_PAYMENT',
    itemDescription: 'ORDERS.NON_PAYMENT',
    icon: 'custom-cancel',
    color: 'dark',
    chartLabel: 'ORDERS.NON_PAYMENT',
    chartColor: '#EE8471',
    ordination: 8,
  } as any,
  UNDEFINED = {
    code: 'UNDEFINED',
    description: '',
    itemDescription: '',
    icon: '',
    color: 'dark',
  } as any,
}



// WEBPACK FOOTER //
// ./src/app/pages/orders/enums/order-status.enum.ts